var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCelebration = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22L16 17L7 8L2 22ZM12.35 16.18L5.3 18.7L7.82 11.65L12.35 16.18Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 12.53L20.12 6.94001C20.61 6.45001 21.4 6.45001 21.89 6.94001L22.48 7.53001L23.54 6.47001L22.95 5.88001C21.88 4.81001 20.13 4.81001 19.06 5.88001L13.47 11.47L14.53 12.53Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 6.88002L9.46997 7.47002L10.53 8.53002L11.12 7.94002C12.19 6.87002 12.19 5.12002 11.12 4.05002L10.53 3.46002L9.46997 4.53002L10.06 5.12002C10.54 5.60002 10.54 6.40002 10.06 6.88002Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 11.88L15.47 13.47L16.53 14.53L18.12 12.94C18.61 12.45 19.4 12.45 19.89 12.94L21.5 14.55L22.56 13.49L20.95 11.88C19.87 10.81 18.13 10.81 17.06 11.88Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.06 5.88002L11.47 9.47002L12.53 10.53L16.12 6.94002C17.19 5.87002 17.19 4.12002 16.12 3.05002L14.53 1.46002L13.47 2.52002L15.06 4.11002C15.54 4.60002 15.54 5.40002 15.06 5.88002Z",
    fill: "#131313"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCelebration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/celebration.c3089513.svg";
export { ForwardRef as ReactComponent };